import React, { useState } from 'react';
import { issueProcessorTypes, visualCheckProcessorTypes, supplementalProcessorTypes, visibilities, namespace } from '@features/IIMRunInitializer/constants';
import Brushaway from '@components/Brushaway';
import apiClient from '@utils/api-client';
import { apiInternalIimRunsPath } from '@routes';
import { translate } from '@utils/i18n';
function IIMRunInitializer({ inspectionId, teaserMode }) {
    const [selectedIssueProcessors, setSelectedIssueProcessors] = useState([]);
    const [selectedVisualProcessors, setSelectedVisualProcessors] = useState([]);
    const [selectedSupplementalProcessors, setSelectedSupplementalProcessors] = useState([]);
    const [selectedVisibility, setSelectedVisibility] = useState(teaserMode ? visibilities[2] : visibilities[0]);
    const [showPopup, setShowPopup] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [runStarted, setRunStarted] = useState(false);
    const handleToggleIssueProcessor = (type) => {
        if (selectedIssueProcessors.some((x) => x.key === type.key))
            setSelectedIssueProcessors(selectedIssueProcessors.filter((x) => x.key !== type.key));
        else
            setSelectedIssueProcessors([...selectedIssueProcessors, type]);
    };
    const handleToggleVisualProcessor = (type) => {
        if (selectedVisualProcessors.some((x) => x.key === type.key))
            setSelectedVisualProcessors(selectedVisualProcessors.filter((x) => x.key !== type.key));
        else
            setSelectedVisualProcessors([...selectedVisualProcessors, type]);
    };
    const handleToggleSupplementalProcessor = (type) => {
        if (selectedSupplementalProcessors.some((x) => x.key === type.key))
            setSelectedSupplementalProcessors(selectedSupplementalProcessors.filter((x) => x.key !== type.key));
        else
            setSelectedSupplementalProcessors([...selectedSupplementalProcessors, type]);
    };
    const toggleAllIssueProcessors = () => {
        if (selectedIssueProcessors.length === issueProcessorTypes.length) {
            setSelectedIssueProcessors([]);
        }
        else {
            setSelectedIssueProcessors(issueProcessorTypes);
        }
    };
    const toggleAllVisualProcessors = () => {
        if (selectedVisualProcessors.length === visualCheckProcessorTypes.length) {
            setSelectedVisualProcessors([]);
        }
        else {
            setSelectedVisualProcessors(visualCheckProcessorTypes);
        }
    };
    const toggleAllSupplementalProcessors = () => {
        if (selectedSupplementalProcessors.length === supplementalProcessorTypes.length) {
            setSelectedSupplementalProcessors([]);
        }
        else {
            setSelectedSupplementalProcessors(supplementalProcessorTypes);
        }
    };
    const totalSelected = selectedIssueProcessors.length + selectedVisualProcessors.length + selectedSupplementalProcessors.length;
    const navigateToIaTab = () => {
        window.location.hash = 'iim-issues';
        window.location.reload();
    };
    const onRunStarted = () => {
        setRunStarted(true);
        setTimeout(navigateToIaTab, 1500);
    };
    const handleRunSubmit = () => {
        setSubmitDisabled(true);
        apiClient
            .post(apiInternalIimRunsPath(), {
            inspectionId,
            issueTypes: [
                ...selectedIssueProcessors,
                ...selectedVisualProcessors,
                ...selectedSupplementalProcessors
            ].map((x) => x.key),
            visibility: selectedVisibility.value,
            published: !teaserMode
        })
            .then(onRunStarted)
            .catch((err) => {
            alert(translate('run_started_failed_message', { namespace }));
            console.error(err);
        })
            .finally(() => {
            setSubmitDisabled(false);
        });
    };
    const handleFullRunSubmit = () => {
        setSubmitDisabled(true);
        apiClient
            .post(apiInternalIimRunsPath(), {
            inspectionId,
            isFullRun: true,
            visibility: selectedVisibility.value,
            published: !teaserMode
        })
            .then(onRunStarted)
            .catch((err) => {
            alert(translate('run_started_failed_message', { namespace }));
            console.error(err);
        })
            .finally(() => {
            setSubmitDisabled(false);
        });
    };
    return (React.createElement("div", null,
        React.createElement("button", { type: "button", className: "qmb-control content-actions", onClick: () => setShowPopup(true) },
            React.createElement("i", { className: "fa-light fa-head-side-gear" }),
            " ",
            translate('button_name', { namespace })),
        React.createElement(Brushaway, { open: showPopup, title: translate('title', { namespace }), onClose: () => setShowPopup(false) },
            runStarted && (React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 0', color: '#2e7d32', fontWeight: 500 } },
                React.createElement("i", { className: "fa-light fa-circle-check", style: { fontSize: '18px' } }),
                translate('run_started_message', { namespace, defaultValue: 'Analysis started — navigating to results…' }))),
            React.createElement("div", null, visibilities.map((visibility) => (React.createElement("div", { key: `visibility_${visibility.key}` },
                React.createElement("label", { className: "qmb-checkbox" },
                    React.createElement("input", { disabled: teaserMode, type: "radio", name: "visibility", checked: selectedVisibility.key === visibility.key, onChange: () => setSelectedVisibility(visibility) }),
                    visibility.name))))),
            React.createElement("hr", null),
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("label", { className: "qmb-checkbox" },
                        React.createElement("input", { type: "checkbox", checked: selectedIssueProcessors.length === issueProcessorTypes.length, onChange: () => toggleAllIssueProcessors() }),
                        translate('all_issues', { namespace }))),
                React.createElement("div", null,
                    React.createElement("label", { className: "qmb-checkbox" },
                        React.createElement("input", { type: "checkbox", checked: selectedVisualProcessors.length === visualCheckProcessorTypes.length, onChange: () => toggleAllVisualProcessors() }),
                        translate('all_visual_checks', { namespace }))),
                supplementalProcessorTypes.length > 0 && (React.createElement("div", null,
                    React.createElement("label", { className: "qmb-checkbox" },
                        React.createElement("input", { type: "checkbox", checked: selectedSupplementalProcessors.length === supplementalProcessorTypes.length, onChange: () => toggleAllSupplementalProcessors() }),
                        translate('all_supplemental', { namespace }))))),
            React.createElement("hr", null),
            React.createElement("span", null,
                translate('issue_detection_processors', { namespace }),
                ":"),
            React.createElement("div", { style: { marginTop: '2rem' } }, issueProcessorTypes.map((processor) => (React.createElement("div", { key: `issue_processor_${processor.key}` },
                React.createElement("label", { className: "qmb-checkbox" },
                    React.createElement("input", { type: "checkbox", checked: selectedIssueProcessors.some((x) => x.key === processor.key), onChange: () => handleToggleIssueProcessor(processor) }),
                    processor.name))))),
            React.createElement("hr", null),
            React.createElement("span", null,
                translate('visual_check_processors', { namespace }),
                ":"),
            React.createElement("div", { style: { marginTop: '2rem' } }, visualCheckProcessorTypes.map((processor) => (React.createElement("div", { key: `visual_processor_${processor.key}` },
                React.createElement("label", { className: "qmb-checkbox" },
                    React.createElement("input", { type: "checkbox", checked: selectedVisualProcessors.some((x) => x.key === processor.key), onChange: () => handleToggleVisualProcessor(processor) }),
                    React.createElement("i", { className: processor.icon, style: { marginRight: '6px' } }),
                    processor.name))))),
            supplementalProcessorTypes.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("hr", null),
                React.createElement("span", null,
                    translate('supplemental_processors', { namespace }),
                    ":"),
                " ",
                React.createElement("br", null),
                React.createElement("div", { style: { marginTop: '2rem' } }, supplementalProcessorTypes.map((processor) => (React.createElement("div", { key: `supplemental_processor_${processor.key}` },
                    React.createElement("label", { className: "qmb-checkbox" },
                        React.createElement("input", { type: "checkbox", checked: selectedSupplementalProcessors.some((x) => x.key === processor.key), onChange: () => handleToggleSupplementalProcessor(processor) }),
                        processor.name))))))),
            React.createElement("hr", null),
            React.createElement("button", { type: "button", disabled: totalSelected === 0 || submitDisabled, onClick: handleRunSubmit }, translate('start_run', { namespace })),
            React.createElement("br", null),
            React.createElement("button", { type: "button", onClick: handleFullRunSubmit }, translate('start_full_run', { namespace })),
            React.createElement("small", null, translate('full_run_processors_configured_by_env_settings', { namespace })))));
}
export default IIMRunInitializer;
